import { render, staticRenderFns } from "./SdlMetrics.vue?vue&type=template&id=51d5a0d2&scoped=true&"
import script from "./SdlMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SdlMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SdlMetrics.vue?vue&type=style&index=0&id=51d5a0d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5a0d2",
  null
  
)

export default component.exports